import * as React from 'react'

import { AuthConfigContext } from '../providers/AuthenticationProvider'

export const useAuthentication = () => {
  return React.useContext(AuthConfigContext)
}
